<!--PILOTSTATION - NIET INKOMENDE REIZEN-->
@if (!context.visit.orderIncomingMovement) {
  <div div class="d-flex flex-column">
    <div class="fieldset">
      @if (context.visit.visitDeclaration.portVisit.pilotStation != null) {
        <div class="row g-0">
          <div class="col">
            <app-select [(ngModel)]="context.visit.visitDeclaration.portVisit.pilotStation"
                        [optionsProvider]="pilotStations"
                        dataKey="name" [formatter]="pilotBoardingPlaceFormatter"
                        placeholder="– Select pilot boarding place –"
                        required
                        [disabled]="context.isArrived()" id="pilotStation">
              <div class="invalid-feedback">Please select a pilot boarding place</div>
            </app-select>
          </div>
          <div class="col-3 d-none d-xl-block ps-2 validatable" style="min-width: 16rem">
            <div>
              @if (!context.visit.orderIncomingMovement) {
                <app-date-field
                  [(ngModel)]="context.visit.visitDeclaration.portVisit.etaPort" required
                  (ngModelChange)="context.shiftTime(context.visit.visitDeclaration.portVisit, 'etaPort', $event)"
                  [calendarStartDate]="context.visit.visitDeclaration.portVisit.etdPort"
                  [disabled]="context.isArrived()"
                  id="portEta"></app-date-field>
              }
            </div>
            @if (validator.etaPortIsSameOrBeforePreviousPort()) {
              <span class="ng-invalid invalid-feedback mb-2">Last previous port should be
              before eta pilot boarding place</span>
            }
            @if (validator.etaPortIsSameOrAfterFirstBerth()) {
              <span class="ng-invalid invalid-feedback mb-2">First berth visit should be after
              eta port</span>
            }
            @if (validator.etaPortIsSameOrAfterEtdPort()) {
              <span class="ng-invalid invalid-feedback mb-2">Eta port should be before etd
              port</span>
            }
          </div>
        </div>
      }
    </div>
  </div>
}

